export default __webpack_public_path__ + "static/media/swoosh.8e28bc9c.mp3";